import { createContext, useContext, useEffect, useMemo, useState } from "react";

const ThemeContext = createContext(null);
const LS_KEY = "trt_theme_v1";

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    try {
      return localStorage.getItem(LS_KEY) || "dark";
    } catch (err) {
      if (process.env.NODE_ENV === "development") {
        console.warn("[theme] localStorage read failed:", err);
      }
      return "dark";
    }
  });

  useEffect(() => {
    const html = document.documentElement;
    html.classList.remove("theme-dark", "theme-light");
    html.classList.add(`theme-${theme}`);
    try {
      localStorage.setItem(LS_KEY, theme);
    } catch (err) {
      if (process.env.NODE_ENV === "development") {
        console.warn("[theme] localStorage write failed:", err);
      }
    }
  }, [theme]);

  const value = useMemo(
    () => ({
      theme,
      setTheme,
      toggle: () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    }),
    [theme]
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used within ThemeProvider");
  return ctx;
}
